import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  standalone: false,
  selector: 'app-groups-roles',
  templateUrl: './groups-roles.component.html',
  styleUrls: ['./groups-roles.component.scss']
})
export class GroupsRolesComponent {
  items: MenuItem[] = [];
  activeItem!: MenuItem;
  constructor() {
    this.items = [
      { label: 'Policy Groups', routerLink: ['policy-groups'] },
      { label: 'Roles', routerLink: ['roles'] }
    ];
    this.activeItem = this.items[0];
  }
}
